import React, { useState, useCallback } from 'react';
import { getAllReservations } from '../../../services/OrderService';
import ReservationHistoryList from '../../components/OrderHistory/ReservationHistoryList';

const ReservationHistory = () => {
    const [reservationData, setReservationData] = useState({
        data: [],
        current_page: 1,
        total_pages: 1
    });
    const [pageItems, setPageItems] = useState(10);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const getReservations = useCallback((page = 1, itemsPerPage = pageItems) => {
        getAllReservations(page, itemsPerPage, fromDate, toDate)
            .then(response => {
                setReservationData({
                    data: response.data || [],
                    current_page: response.current_page || 1,
                    total_pages: response.total_pages || 1
                });
                setPageItems(itemsPerPage);
            })
            .catch(error => {
                console.error("Error fetching reservations:", error);
            });
    }, [fromDate, toDate, pageItems]);

    const handlePageChange = (page) => {
        getReservations(page, pageItems);
    };

    const handlePageItemsChange = (items) => {
        setPageItems(items);
        getReservations(1, items);
    };

    const handleDateFilter = (from, to) => {
        setFromDate(from);
        setToDate(to);
        getReservations(1, pageItems, from, to);
    };

    return (
        <ReservationHistoryList 
            reservationList={reservationData.data}
            getReservations={getReservations}
            pagination={{
                currentPage: reservationData.current_page,
                totalPages: reservationData.total_pages
            }}
            pageItems={pageItems}
            onPageChange={handlePageChange}
            onPageItemsChange={handlePageItemsChange}
            onDateFilter={handleDateFilter}
        />
    );
}

export default ReservationHistory;
